// Shared date/time parse + format primitives for the event form controllers
// (event_wizard, event_form_summary). Those controllers build different
// high-level schedule summaries (the wizard's terse review string vs. the
// form summary's rich i18n sentence), so only these low-level primitives are
// shared — each controller keeps its own summary composition.
//
// All formatters use the browser locale (undefined) and fall back gracefully
// if Intl throws.

export function parseDateTime(raw: string): Date | null {
  if (!raw) return null;
  const date = new Date(raw);
  return isNaN(date.getTime()) ? null : date;
}

// Date-only strings ("2026-05-04") are pinned to local midnight rather than
// being parsed as UTC (which would shift the day in negative-offset zones).
export function parseDateOnly(raw: string): Date | null {
  if (!raw) return null;
  const value = raw.length === 10 ? `${raw}T00:00:00` : raw;
  const date = new Date(value);
  return isNaN(date.getTime()) ? null : date;
}

export function formatDate(date: Date, options: { year?: boolean } = {}): string {
  const opts: Intl.DateTimeFormatOptions = { month: "short", day: "numeric" };
  if (options.year) opts.year = "numeric";
  try {
    return date.toLocaleDateString(undefined, opts);
  } catch {
    return date.toDateString();
  }
}

export function formatTime(date: Date): string {
  try {
    return date.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
  } catch {
    return date.toTimeString().substring(0, 5);
  }
}

export function formatDateTime(date: Date): string {
  try {
    return date.toLocaleString(undefined, {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
  } catch {
    return date.toString();
  }
}
